import { render, staticRenderFns } from "./GardenerSales.vue?vue&type=template&id=85a5de68&scoped=true"
import script from "./GardenerSales.vue?vue&type=script&lang=js"
export * from "./GardenerSales.vue?vue&type=script&lang=js"
import style0 from "./GardenerSales.vue?vue&type=style&index=0&id=85a5de68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a5de68",
  null
  
)

export default component.exports